export const Nuxt = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width="500"
      height="500"
      viewBox="0 0 500 500"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <path
        d="M273.76 383H420.28C424.955 383 429.431 381.351 433.48 379.025C437.529 376.699 441.703 373.779 444.04 369.749C446.377 365.721 448.002 361.15 448 356.499C447.998 351.847 446.381 347.278 444.04 343.251L345.04 172.325C342.703 168.297 339.848 165.376 335.8 163.05C331.752 160.725 325.954 159.075 321.28 159.075C316.606 159.075 312.128 160.725 308.08 163.05C304.032 165.376 301.176 168.297 298.84 172.325L273.76 216.05L223.6 131.247C221.261 127.219 218.41 122.975 214.36 120.65C210.31 118.324 205.836 118 201.16 118C196.485 118 192.009 118.324 187.96 120.65C183.911 122.975 179.739 127.219 177.4 131.247L54.64 343.251C52.2996 347.278 52.0021 351.847 52 356.499C51.998 361.15 52.3032 365.72 54.64 369.749C56.9769 373.778 61.1509 376.699 65.2 379.025C69.2492 381.351 73.7243 383 78.4 383H170.8C207.412 383 234.061 366.514 252.64 335.3L297.52 257.125L321.28 216.05L393.88 340.6H297.52L273.76 383ZM169.48 340.6H104.8L201.16 173.65L250 257.125L217.648 313.735C205.311 333.988 191.244 340.6 169.48 340.6Z"
        fill="currentColor"
      />
    </svg>
  )
}
